import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

// API
import { GetOrganizationById } from '../GetOrganizationById';

export const useOrganization = ({ clientId }: { clientId?: string }) => {
    const { t } = useTranslation();
    const query = useQuery({
        queryKey: ['clientRecordById', clientId],
        queryFn: async () => {
            if (clientId) {
                const response = await GetOrganizationById(clientId);

                return response ?? undefined;
            }

            return undefined;
        },
        enabled: !!clientId
    });

    return {
        data: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
        refetch: async () => {
            await query.refetch();
        }
    };
};
